import BannerComp from "../../components/BannerComp";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import IconBenefitGrid from "../../components/IconBenefitGrid";
import ImageTextSection from "../../components/ImageTextSection";
import NumbersFlow from "../../components/NumbersFlow";
import Seo from "../../components/Seo";
import {
  benefitsData,
  collectionSteps,
  stepper,
} from "../../data/transcranial";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";

import section1Image from "./tms_section1.webp";
import section2Image from "./tms_section2.webp";

const seo = {
  title: "Transcranial Magnetic Stimulation Therapy | MIT4Doctors",
  description:
    "Enhance your practice with MITSI's advanced TMS therapy, offering new depression treatments with no advance payments, trained staff, and full support.",
  schema: [
    createWebPageSchema({
      path: "/services/transcranial-magnetic-stimulation",
      title: "Transcranial Magnetic Stimulation Therapy",
      description:
        "Enhance your practice with MITSI advanced TMS therapy services. Our program lets providers offer new depression treatments with no advance payments. With MITSI, you get a flawless solution. It includes trained staff, advanced equipment, and end-to-end support.",
    }),
    createBreadcrumbSchema(
      "/services/transcranial-magnetic-stimulation",
      "Transcranial Magnetic Stimulation Therapy",
    ),
  ],
};

export default function TranscranialMagneticStimulation() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/transcranial-magnetic-stimulation"
        schema={seo.schema}
      />
      <BannerComp
        heading="Transcranial Magnetic Stimulation Therapy"
        paragraph="Enhance your practice with MITSI advanced TMS therapy services. Our program lets providers offer new depression treatments with no advance payments. With MITSI, you get a flawless solution. It includes trained staff, advanced equipment, and end-to-end support."
        centered
        BannerBgImg="/img/banners/transcranial_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="What is TMS Therapy ?"
        imagePosition="left"
        title="What is TMS Therapy ?"
        description="Transcranial Magnetic Stimulation (TMS) uses magnetic pulses to mood-regulating areas in the brain. This FDA-approved therapy offers new hope for those with stubborn depression. When medications fail, TMS provides a proven, non-invasive alternative. It lights the way for patients in darkness, bringing hope when other treatments fail."
        highlightWords="Therapy"
      />

      <FeatureFlow
        heading="Core Feature of TMS Therapy"
        highlights={["Therapy"]}
        paragraph="TMS therapy is a safe, non-invasive, and drug-free treatment for mental health conditions. It uses advanced figure-8 coils for precise, effective therapy. It prioritizes patient comfort with ergonomic head and neck support. FDA-approved, pre-installed protocols ensure efficient, customized sessions for optimal results."
        steps={stepper}
      />

      <FeatureImageContent
        heading="Start Right Away"
        description="Transform your practice with MITSI TMS therapy services. Contact us to learn more about this life-changing treatment. It can help your patients and increase your clinic's revenue."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Start Right Away"
      />

      <NumbersFlow
        eyebrow="TMS Treatment Program"
        heading="How Our Program Works"
        highlights={["Program"]}
        intro="Our TMS program provides the equipment, trained staff, billing support, and ongoing assistance needed to deliver efficient and patient-focused treatment."
        steps={collectionSteps}
      />

      <IconBenefitGrid
        title="Value of the MITSI TMS Program"
        description="MITSI’s TMS program provides a cost-effective way to add a new revenue stream to your practice with no initial expenses. It’s fully supported, covered by most insurers, and seamlessly integrates into your workflow. TMS also complements other treatments for a holistic approach to patient care."
        highlightWords="Program"
        items={benefitsData}
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Why Choose TMS Therapy with MITSI ?"
        imagePosition="right"
        title="Why Choose TMS Therapy with MITSI ?"
        subSections={[
          {
            listItems: [
              "Effective, non-drug treatment for depression.",
              "Backed by cutting-edge technology and reliable equipment.",
              "Fully managed solution with no administrative burden on your team.",
              "Proven to improve patient outcomes and satisfaction.",
            ],
          },
        ]}
        highlightWords="MITSI"
        icon={true}
      />
    </>
  );
}
